// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8o-4";
export var collapsed = "_8o-1";
export var headerBar = "_8o-0";
export var leftHeaderContent = "_8o-3";
export var subjectContainer = "_8o-2";